module.exports = __webpack_public_path__ + "static/media/home delivary.44e1602b.png";